<template>
  <v-card class="pa-5 base-planner">
    <FullCalendar ref="full_calendar" :options="calendarOptions" />
  </v-card>
</template>

<script>
import FullCalendar from '@fullcalendar/vue3';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import moment from "moment";
import helpFunctions from "../../plugins/helpFunctions";

export default {
  components: { FullCalendar },
  props: ["trainings", "sessions"],
  data() {
    return {
      page: helpFunctions.pages.planner,
      calendarOptions: {
        schedulerLicenseKey: '0428499722-fcs-1583088865',
        plugins: [dayGridPlugin, interactionPlugin],
        headerToolbar: {
          start: 'today prev,next',
          center: 'title',
          end: ''
        },
        initialView: 'dayGridMonth',
        //eventDisplay: 'background',
        height: 'auto',
        contentHeight: 'auto',
        editable: false,
        events: [],
      }
    }
  },
  methods: {
    load() {
      this.clearCalendar();

      this.trainings.forEach((training) => {
        for (let x = 0; x < training.amount_of_days; x++) {
          if(training.dates[x]) {
            this.$refs.full_calendar.getApi().addEvent({
              "id": training.id + '-' + x,
              "allDay": true,
              "start": moment(training.dates[x], "DD-MM-YYYY").toDate(),
              "end": moment(training.dates[x], "DD-MM-YYYY").add(1, 'days').toDate(),
              "title": training.name + ' ' + this.$store.getters.translate('day') + ' ' + (x + 1),
              "color": '#8fdf82',
            });
          }
        }
      });

      this.sessions.forEach((session) => {
        session.exam_candidate_sessions.forEach((ecs) => {
          if(ecs.examination_date) {
            let from = moment(ecs.examination_date + " " + ecs.from, "DD-MM-YYYY HH:mm");
            let till = moment(ecs.examination_date + " " + ecs.till, "DD-MM-YYYY HH:mm");
            this.$refs.full_calendar.getApi().addEvent({
              "id": 'exam-' + ecs.id,
              //"allDay": false,
              "start": from.toDate(),
              "end": till.toDate(),
              "title": session.name
                  + ' - ' + ecs.candidate.casual_name
                  + ' - ' + from.format('HH:mm')
                  + ' - ' + till.format('HH:mm'),
              "color": 'lightskyblue',
            });
          }
        });
      });

      this.$nextTick(() => {
        const api = this.$refs.full_calendar?.getApi();
        if (api) {
          api.updateSize();
        }
      });
    },
    clearCalendar() {
      let removeEvents = this.$refs.full_calendar.getApi().getEvents();
      removeEvents.forEach(event => event.remove());
      this.$refs.full_calendar.getApi().refetchResources();
    },
  },
}
</script>

<style>
.base-planner .fc-daygrid-event .fc-event-title {
  white-space: normal !important;
}

.fc-bg-event {
  opacity: unset !important;
}
.fc-day-sun, .fc-day-sat {
  background-color: #f2f2f2;
}
.fc-license-message {
  visibility: hidden;
}
.fc-datagrid-cell-main {
  font-size: 14px;
}
.fc-icon {
  height: auto;
}
.fc-button {
  border-radius: 24px !important;
  background: transparent !important;
  border: 1px solid rgba(232, 232, 232) !important;
  color: rgb(var(--v-theme-primary)) !important;
  font-family: Inter, sans-serif !important;
  font-weight: 500 !important;
  font-size: 16px !important;
  line-height: 150% !important;
  padding: 12px 24px !important;
  height: 42px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-sizing: border-box !important;
}
.fc-button:has(.fc-icon) {
  max-width: 64px !important;
  margin-inline: 4px !important;
}
.fc-icon {
  vertical-align: unset !important;
}
.fc--button {
  display:none !important;
}
</style>